import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { createUserEpic } from './_epics/createUser.epic';
import { createClientUserEpic } from './_epics/createClientUser.epic';

export const userEpic = safeCombineEpics(
  createUserEpic,
);

export const clientUserEpic = safeCombineEpics(
  createClientUserEpic,
);
